import { INewsLetter } from '@/interfaces/entities/newsLetter';
import { ApiRequestConfig, apiService } from './api.service';

import { IApiService } from '@/interfaces/services/IApiService';

class NewsLetterService {
    api: IApiService<ApiRequestConfig>;

    constructor(api: IApiService<ApiRequestConfig>) {
        this.api = api;
    }

    async getAllNewsLetters(pageNumber: number, config?: ApiRequestConfig) {
        return await this.api.get<{ data: INewsLetter[]; pageCount: number }>(
            `/newsLetter?page[number]=${pageNumber}&sort[id]=DESC`,
            config,
        );
    }

    async deleteNewsLetter(id: number) {
        return await this.api.delete(`/newsLetter/${id}`);
    }

    async editNewsLetter(id: number, newsLetter: FormData) {
        return await this.api.patch(`/newsLetter/edit/${id}`, newsLetter, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        
    }

    async newNewsLetter(newsLetter: FormData) {
        return await this.api.post(`/newsLetter`, newsLetter, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
}

export const newsLetterService = new NewsLetterService(apiService);
